import React from 'react';
import { CHECKOUT_URL, PRODUCT_IMG, PRODUCT_NAME } from './constants';
const modules = [{
  num: '1',
  title: 'Occupational Therapy Foundations™',
  description: 'Master the essential clinical reasoning models, assessment frameworks, goal-setting systems (SMART+O), intervention planning, and professional standards needed to deliver high-quality, patient-centered care.'
}, {
  num: '2',
  title: 'Activity & Intervention Library™',
  description: 'A complete collection of fine motor, gross motor, sensory, cognitive, and ADL interventions with step-by-step progressions, regressions, clinical cues, and practical applications for all populations.'
}, {
  num: '3',
  title: 'Therapy Session Builder™',
  description: 'Professional planning templates and decision frameworks that allow you to build structured, effective 30, 45, or 60-minute sessions in just minutes for individuals or therapy groups.'
}, {
  num: '4',
  title: 'Ready-to-Use Therapy Plans™',
  description: 'A complete library of ready-to-use therapy sessions for various conditions, organized by clinical goals, developmental stages, and rehabilitation needs.'
}, {
  num: '5',
  title: 'Progressive Treatment Programs™',
  description: 'Professional multi-week treatment programs (4, 6, and 8 weeks) including weekly session content, progression maps, reassessment protocols, and long-term maintenance frameworks.'
}, {
  num: '6',
  title: 'Professional OT Toolkit™',
  description: 'Essential clinical resources including initial evaluations, SOAP note templates, progress trackers, session logs, home program forms, and daily organization tools to keep your practice organized.'
}];
export function SystemSection() {
  return <section className="bg-white px-4 py-6" data-id="element-156" data-mp="1bbhiit1aeoy">
      <div className="mx-auto max-w-4xl" data-id="element-157" data-mp="1eh8k3l83qnb">
        <div className="mb-4 text-center" data-id="element-158" data-mp="6bprw7i3y0q5">
          <p className="mb-1 text-xs font-extrabold uppercase tracking-widest text-brand-blue sm:text-sm" data-id="element-159" data-mp="6cr44fav0t9g">
            THE SOLUTION YOU'VE BEEN LOOKING FOR
          </p>
          <h2 className="mb-1 text-2xl font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-160" data-mp="24031r6ee17dr">
            ONE COMPLETE 6-IN-1 OCCUPATIONAL THERAPY CLINICAL SYSTEM
          </h2>
          <p className="mb-2 text-sm font-bold text-brand-navy sm:text-base" data-id="element-161" data-mp="1u9qkbn1vdubu">
            6 Professional Modules In One Complete OT System
          </p>
          <div className="mb-2 inline-block rounded-lg bg-brand-navy px-3 py-1.5 text-white shadow-md" data-id="element-162" data-mp="1pbgjowxdm1iu">
            <p className="font-display text-sm font-bold tracking-wide sm:text-base" data-id="element-163" data-mp="1lan0gguvpawa">
              💪 {PRODUCT_NAME} — Complete 6-in-1 Planning System
            </p>
          </div>
          <p className="mx-auto max-w-3xl text-sm font-medium leading-snug text-brand-slate sm:text-base" data-id="element-164" data-mp="1bbxi6mz2lofi">
            {PRODUCT_NAME} is much more than a collection of activities and exercise ideas. It's a complete clinical system designed to help Occupational Therapists plan therapy faster, build professional rehabilitation programs, organize patient progressions, simplify documentation, and treat every patient with greater confidence.
          </p>
        </div>

        <div className="grid gap-2.5 sm:grid-cols-2" data-id="element-165" data-mp="3mxg5w81b2y8x">
          {modules.map(m => <a key={m.num} href={CHECKOUT_URL} className="group flex cursor-pointer gap-3 rounded-xl border border-brand-line bg-brand-cloud p-3 shadow-sm transition-all hover:border-brand-blue hover:shadow-md" data-id="element-166" data-mp="3rxcao9htutpj">
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand-navy font-display text-sm font-extrabold text-white transition-colors group-hover:bg-brand-blue" data-id="element-167" data-mp="2z9yguk9fee9n">
                {m.num}
              </div>
              <div data-id="element-168" data-mp="jfxvpty29f5c">
                <h3 className="text-sm font-bold leading-tight text-brand-ink sm:text-base" data-id="element-169" data-mp="jghe1brmi5jw">
                  ✅ {m.title}
                </h3>
                <p className="mt-0.5 text-xs font-medium leading-snug text-brand-slate sm:text-sm" data-id="element-170" data-mp="m1fgp354s9uy">
                  {m.description}
                </p>
              </div>
            </a>)}
        </div>

        <div className="mt-5 text-center" data-id="element-171" data-mp="w04mvyno05vd">
          <a href={CHECKOUT_URL} className="inline-block cursor-pointer" data-id="element-172" data-mp="w1698za4sese">
            <img src={PRODUCT_IMG} alt="Occupational Therapist Pro 6-in-1 system" className="mx-auto w-full max-w-xs object-contain drop-shadow-xl transition-transform duration-200 hover:scale-[1.02]" data-id="element-173" data-mp="qzgwnf79ft27" />
          </a>
        </div>
      </div>
    </section>;
}